export default "__VITE_ASSET___Jt9iiW5__"